import { MiscInvoiceProcessingToolPanel } from "../MiscInvoiceProcessingToolPanel";
import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoiceProcessingReady extends Layout {
    layoutMiscInvoiceProcessingToolPanel: MiscInvoiceProcessingToolPanel;
    panelSecondaryFilters: Panel;
    sourceMiscBill: DataSource;
    tableMiscInvoice: Table;
}
